const bookingsReceived = async ({ dispatch, injectReducer }) => {
  const {
    getBookingsReceived,
    default: reducer
    // eslint-disable-next-line global-require
  } = require('../stores/bookingsReceived');

  injectReducer(reducer);

  return dispatch(getBookingsReceived({ page: 1, filter: 'active' }));
};

export default bookingsReceived;
